module.exports = __webpack_public_path__ + "img/clinic_ladies_on_click.ef2384ab.jpg";